import colors from '@styles/colors.module.scss';

export const getNavItemLabelColor = (isActive: boolean): string => {
    const colorString = `--navi-color-navigation-blue-${isActive ? 'c1' : 'c2'}`;
    return colors[colorString];
};
